import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[clubId]/stats/page.tsx");
